<template>
  <div class="booking-deadline-input">
    <div class="booking-deadline-input__fields">
      <div>
        <label :for="`${id}-date`">Date</label>
        <app-date-picker :value="date" :disabled="disabled" :error="error" :input-attr="{ id: `${id}-date`, 'aria-label': `${label} date` }" placeholder="Select date" @input="dateChanged" @input-error="invalidDate" @input-valid="validDate" />
      </div>
      <div>
        <label :for="`${id}-time`">Time</label>
        <app-date-picker :value="time" type="time" format="HH:mm" value-type="HH:mm" time-title-format="HH:mm" :editable="false" :show-second="false" :clearable="false" :disabled="disabled" :error="error" :input-attr="{ id: `${id}-time`, 'aria-label': `${label} time` }" placeholder="HH:mm" @input="timeChanged" />
      </div>
      <button type="button" class="booking-deadline-input__clear" :disabled="disabled || (!date && !time && !dateInvalid)" :aria-label="`Clear ${label}`" :title="`Clear ${label}`" @click="clear"><i class="pi pi-times" aria-hidden="true" /></button>
    </div>
  </div>
</template>

<script>
import { deadlinePayload } from '@/views/flights/bookings/booking-manual-actions'

export default {
  name: 'BookingDeadlineInput',
  props: { value: { type: String, default: '' }, id: { type: String, required: true }, label: { type: String, required: true }, disabled: Boolean, error: Boolean },
  data() { return { date: '', time: '', dateInvalid: false } },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        if ((value || '') === this.combined()) return
        const parts = (value || '').split(' ')
        this.date = parts[0] || ''
        this.time = parts[1] || ''
        this.dateInvalid = false
      }
    }
  },
  methods: {
    combined() { return this.date || this.time ? `${this.date || ''} ${this.time || ''}` : '' },
    emitValue() {
      const value = this.combined()
      this.$emit('input', value)
      this.$emit(this.dateInvalid || (value && !deadlinePayload(value)) ? 'input-error' : 'input-valid')
    },
    dateChanged(value) { this.date = value || ''; this.emitValue() },
    timeChanged(value) { this.time = value || ''; this.emitValue() },
    invalidDate() { this.dateInvalid = true; this.$emit('input-error') },
    validDate() { this.dateInvalid = false; this.emitValue() },
    clear() {
      this.date = ''
      this.time = ''
      this.dateInvalid = false
      this.$emit('input', '')
      this.$emit('input-valid')
    }
  }
}
</script>

<style lang="scss" scoped>
.booking-deadline-input__fields { display: grid; grid-template-columns: minmax(0, 1fr) 112px 28px; align-items: end; gap: 8px; }
.booking-deadline-input__fields > div { min-width: 0; }
.booking-deadline-input__fields label { display: block; margin-bottom: 6px; color: $color-text-second; font-size: 12px; }
.booking-deadline-input__clear { display: grid; place-items: center; height: 38px; padding: 0; border: 0; border-radius: 6px; background: transparent; color: $color-text-second; cursor: pointer; }
.booking-deadline-input__clear:hover:not(:disabled) { background: #f7f8f5; }
.booking-deadline-input__clear:focus-visible { outline: 2px solid $color-theme; outline-offset: 2px; }
.booking-deadline-input__clear:disabled { opacity: .4; cursor: default; }
</style>
